import { Box, Typography, IconButton } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";
import { CloseIcon } from "Components/Shared/Icons/Close";
import { Colors } from "Components/Layout/Themes/Colors";
import { Star } from "@mui/icons-material";

const COMPONENT_RESOURCES = Resources.Hunter.Merchants.NewRegistration;

type Props = {
  companyName?: string;
  licenseNo?: string | null;
  isPrimary?: boolean;
  onRemoveRequested?: () => void;
};

export const HunterCardHeader = ({
  companyName,
  licenseNo,
  isPrimary = false,
  onRemoveRequested,
}: Props) => {
  const { t } = useResource();

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Box display="flex" alignItems="baseline" flexWrap="wrap" gap={1}>
        {isPrimary && <Star sx={{ fontSize: "1rem", alignSelf: "center" }} />}
        <Typography variant="h6" fontSize="1rem" fontWeight={500}>
          {companyName}
        </Typography>
        <Typography variant="h6" fontSize="1rem" fontWeight={200}>
          |
        </Typography>
        <Typography variant="h6" fontSize="0.875rem" color="text.secondary">
          No. {licenseNo || "???"}
        </Typography>
      </Box>
      {onRemoveRequested && (
        <IconButton
          onClick={onRemoveRequested}
          size="small"
          color="error"
          aria-label={t(COMPONENT_RESOURCES.Form.Fields.RemoveHunter)}
        >
          <CloseIcon width="20px" height="20px" color={Colors.DeleteRed} />
        </IconButton>
      )}
    </Box>
  );
};
